import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop(): null {
  const { pathname } = useLocation()

  useEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [pathname])

  return null
}
